
<template>
  <div>
    <div ref="editor" style="text-align:left"></div>
  </div>
</template>

<script>
  import E from 'wangeditor'
  export default {
    name: 'editor',
    props:['content'],
    data () {
      return {
        editor:{},
        editorContent:""
      }
    },
    methods: {
      getHtml:function () {
        return this.editorContent
      }
    },
    watch:{
      'content':function (val) {
        this.editor.txt.html(val)
      }
    },
    mounted:function (){
      this.editor = new E(this.$refs.editor)
      this.editor.customConfig.onchange = (html) => {
        this.editorContent = html
      }
      this.editor.customConfig.uploadImgShowBase64 = true
      this.editor.customConfig.menus = [
        'head',  // 标题
        'bold',  // 粗体
        'fontSize',  // 字号
        'fontName',  // 字体
        'italic',  // 斜体
        'underline',  // 下划线
        'strikeThrough',  // 删除线
        'foreColor',  // 文字颜色
        'backColor',  // 背景颜色
        // 'link',  // 插入链接
        // 'list',  // 列表
        'justify',  // 对齐方式
        'quote',  // 引用
        'emoticon',  // 表情
        'image',  // 插入图片
        'table',  // 表格
        // 'video',  // 插入视频
        // 'code',  // 插入代码
        'undo',  // 撤销
        // 'redo'  // 重复
      ]
      this.editor.customConfig.onblur = (html) => {
        this.$emit('on-blur',html)
      }
      this.editor.create()
      this.editor.txt.html(this.content)
    }
  }
</script>